/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon20Regular = forwardRef('DataChartTrendXyUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.75 4a.75.75 0 0 0-1.5 0v12A2.75 2.75 0 0 0 4 18.75h14a.75.75 0 0 0 0-1.5H4c-.69 0-1.25-.56-1.25-1.25V4Z" }),
        React.createElement("path", { d: "M18.464 6.468a.75.75 0 1 0-1.06-1.06l-5.36 5.359L9.73 8.453a1.25 1.25 0 0 0-1.767 0l-3.18 3.18a.75.75 0 0 0 1.06 1.061l3.003-3.003 2.314 2.313a1.25 1.25 0 0 0 1.768 0l5.536-5.536Z" })));
});
